import Swiper, { Navigation, Autoplay } from 'swiper';

Swiper.use([Navigation, Autoplay]);

const instagramSlider = () => {
  const selectors = {
    slider: '.js-instagram-swiper',
    prevElem: '.js-slider-arrow-prev',
    nextEl: '.js-slider-arrow-next',
  };

  const elem = document.querySelector(selectors.slider);

  if (!elem) return;

  const swiper = new Swiper(elem, {
    slidesPerView: 'auto',
    navigation: {
      prevEl: selectors.prevElem,
      nextEl: selectors.nextEl,
    },
  });
};

export default instagramSlider;
